import { handleActions } from 'redux-actions'
import * as type from './type'
import { changeTableSettings, createInitialTableState } from '../../../form/state/table-state-helper'
import { createInitialTableState as c2, createReducerFunction, DESC } from '../../../table/state/reducer'


export const initialState = {
    taskList: [],
    allOpenTaskList: [],
    allOpenTask: {},
    fetching: false,
    error: null,
    ...createInitialTableState({
        rowsPerPage: 20,
        sortColumnName: 'created',
        sortOrder: -1,
    }),

    ...c2(type.TABLE_ALL_OPEN_TASK, 'process_task_all', {
        'process_task.created': DESC,
    }),
}


export default handleActions({
    ...createReducerFunction(type.TABLE_ALL_OPEN_TASK),

    [type.CHANGE_TABLE_SETTING]: changeTableSettings(),

    [type.FIND_TASK_LIST_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.FIND_TASK_LIST_SUCCESS]: (state, action) => {
        const { taskList } = action.payload
        return {
            ...state,
            taskList,
            fetching: false,
        }
    },
    [type.FIND_TASK_LIST_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/process/state/task-list/reducer.js